module.exports = __webpack_public_path__ + "img/DE02860.a837c5c5.png";